module.exports = __webpack_public_path__ + "static/html-element-65550459ef6e27fdcfdc7bbc8cf0539f.jpg";